import { html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './dropdown-list.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class DropdownList extends OutlineElement {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      list: { type: Array },
      key: { type: String },
      isHPSite: { type: Boolean },
      open: { type: Boolean },
    };
  }

  constructor() {
    super();
    this.open = false;
    this.isHPSite = false;
    this.key = false;
  }

  renderList() {
    const templateResult = [];

    for (const [listkey, listdata] of Object.entries(this.list)) {
      templateResult.push(
        html` <li
          class="${classMap({
            'dropdown-list__item': true,
            'dropdown-list__item--active': listdata.active,
            'dropdown-list__item--hp': this.isHPSite,
          })}"
        >
          <a href="${listdata.url}" target="_blank" class="dropdown-list__link"
            >${listdata.text}</a
          >
        </li>`
      );
    }

    return templateResult;
  }

  render() {
    return html`
      <ul
        class="${classMap({
          'dropdown-list': true,
          'dropdown-list--open': this.open,
          [`dropdown-list--${this.key}`]: this.key,
        })}"
      >
        ${this.renderList()}
      </ul>
    `;
  }
}
customElements.define('hf-dropdown-list', DropdownList);
